import React from 'react';
import {
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Stack,
} from '@mui/material';
import Delete from '@mui/icons-material/Delete';

interface PipelineConfigProps {
  selectedStages: string[];
  availableStages: string[];
  onChange: (stages: string[]) => void;
  variant?: 'full' | 'compact';
}

export const PipelineConfig: React.FC<PipelineConfigProps> = ({
  selectedStages,
  availableStages,
  onChange,
  variant = 'full'
}) => {
  const handleStageAdd = (stage: string) => {
    if (stage && !selectedStages.includes(stage)) {
      onChange([...selectedStages, stage]);
    }
  };

  const handleStageRemove = (index: number) => {
    const newStages = selectedStages.filter((_, i) => i !== index);
    onChange(newStages);
  };

  return (
    <Box>
      {variant === 'full' && (
        <>
          <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
            Pipeline Value Stages
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              mb: 2
            }}>
            Select which project stages should be included in the Pipeline Value calculation.
            Only non-completed projects with start dates in the selected period will be counted.
          </Typography>
        </>
      )}
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Selected Stages ({selectedStages.length})
      </Typography>
      <Stack direction="row" spacing={1} sx={{ mb: 2, flexWrap: 'wrap', gap: 1 }}>
        {selectedStages.map((stage, index) => (
          <Chip
            key={index}
            label={stage}
            onDelete={() => handleStageRemove(index)}
            deleteIcon={<Delete />}
            size={variant === 'compact' ? 'small' : 'medium'}
          />
        ))}
      </Stack>
      <FormControl fullWidth size={variant === 'compact' ? 'small' : 'medium'}>
        <InputLabel>Add Stage</InputLabel>
        <Select
          value=""
          label="Add Stage"
          onChange={(e) => {
            const stage = e.target.value as string;
            handleStageAdd(stage);
          }}
        >
          {availableStages
            .filter(stage => stage)
            .map((stage) => (
              <MenuItem key={stage} value={stage}>
                {stage} {selectedStages.includes(stage) ? '(already added)' : ''}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default PipelineConfig; 